if (!customElements.get('product-info')) {
  customElements.define('product-info', class ProductInfo extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.quantity__input');
      this.currentVariant = this.querySelector('.product-variant-id');
      this.variantSelects = this.querySelector('variant-radios')
      this.submitButton = this.querySelector('[type="submit"]');

      this.setRecentlyViewed();

      this.persistentAddToCart = this.querySelector('.product__persistant-container');
      this.syncSizeSelects();
      this.persistentController();
    }

    cartUpdateUnsubscriber = undefined;
    variantChangeUnsubscriber = undefined;

    connectedCallback() {
      if (!this.input) return;
      this.quantityForm = this.querySelector('.product-form__quantity');
      if (!this.quantityForm) return;
      this.setQuantityBoundries();  
      if (!this.dataset.originalSection) {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
      }
      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
        if (event.data.sectionId !== sectionId) return;
        this.updateQuantityRules(event.data.sectionId, event.data.html);
        this.setQuantityBoundries();
      });
    }

    disconnectedCallback() {
      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
      }
      if (this.variantChangeUnsubscriber) {
        this.variantChangeUnsubscriber();
      }
    }

    setQuantityBoundries() {
      const data = {
        cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
        min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
        max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
        step: this.input.step ? parseInt(this.input.step) : 1
      }

      let min = data.min;
      const max = data.max === null ? data.max : data.max - data.cartQuantity;
      if (max !== null) min = Math.min(min, max);
      if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

      this.input.min = min;
      this.input.max = max;
      this.input.value = min;
      publish(PUB_SUB_EVENTS.quantityUpdate, undefined);  
    }

    fetchQuantityRules() {
      if (!this.currentVariant || !this.currentVariant.value) return;
      this.querySelector('.quantity__rules-cart .loading-overlay').classList.remove('hidden');
      fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`).then((response) => {
        return response.text()
      })
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        this.updateQuantityRules(this.dataset.section, html);
        this.setQuantityBoundries();
      })
      .catch(e => {
        console.error(e);
      })
      .finally(() => {
        this.querySelector('.quantity__rules-cart .loading-overlay').classList.add('hidden');
      });
    }

    updateQuantityRules(sectionId, html) {
      const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
      const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
      for (let selector of selectors) { 
        const current = this.quantityForm.querySelector(selector);
        const updated = quantityFormUpdated.querySelector(selector);
        if (!current || !updated) continue;
        if (selector === '.quantity__input') {
          const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
          for (let attribute of attributes) {
            const valueUpdated = updated.getAttribute(attribute);
            if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
          }
        } else {
          current.innerHTML = updated.innerHTML;
        }
      }
    }

    setRecentlyViewed() {
      const productHandle = this.dataset.productHandle;
      const storageKey = 'bnkr-recently-viewed';
      let viewedItems = [];
    
      if (localStorage.getItem(storageKey)) {
        viewedItems = JSON.parse(localStorage.getItem(storageKey));
        let itemExists = false;
    
        for (let i = 0; i < viewedItems.length; i++) {
          if (viewedItems[i].handle === productHandle) {
            viewedItems.splice(i, 1); // remove item from array
            viewedItems.unshift({ handle: productHandle }); // insert at beginning
            itemExists = true;
            break;
          }
        }
    
        if (!itemExists) {
          if (viewedItems.length >= 11) {
            viewedItems.pop(); // drop off the oldest product
          }
          viewedItems.unshift({ handle: productHandle });
        }
    
        localStorage.setItem(storageKey, JSON.stringify(viewedItems));
      } else {
        viewedItems.push({ handle: productHandle });
        localStorage.setItem(storageKey, JSON.stringify(viewedItems));
      }
    }

    persistentController() {
      const atcButton = this.querySelector('.product-form .product-form__buttons');
      const atcHeight = atcButton.offsetHeight;
      const atcPosition = atcButton.offsetTop;

      if (atcPosition === 0 || window.innerWidth > 750) return;

      this.persistentAddToCart.classList.remove('hidden');
      
      window.addEventListener('scroll', () => {
        if (window.scrollY > atcPosition + atcHeight) {
          this.persistentAddToCart.classList.add('active')
        } else {
          this.persistentAddToCart.classList.remove('active')
        }
      })
    }

    syncSizeSelects() {
      this.sizeSelects = this.querySelectorAll('.select__select--size');

      this.sizeSelects.forEach(select => {
        select.addEventListener('change', () => {
          this.updateSizeSelects(select);
        });
      })
    }

    updateSizeSelects(changedSelect) {
      this.sizeSelects.forEach(select => {
        if (select !== changedSelect) {
          select.value = changedSelect.value;
        }
      })
    }
  }
)};